import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

export const getUserProfile = createAsyncThunk('user/profile', async () => {
	return await AccountService.profile();
});
